
import { QueryClient } from '@tanstack/react-query';

/**
 * Creates and configures a query client with default options
 */
export const createQueryClient = (options?: {
  defaultOptions?: {
    queries?: {
      staleTime?: number;
      retry?: number;
      [key: string]: any;
    };
    [key: string]: any;
  };
  [key: string]: any;
}) => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        retry: 2,
        ...options?.defaultOptions?.queries,
      },
    },
    ...options,
  });
};
